<template>
    <div> UNUSED!</div>
<!--    <div class="portfolio-settings">-->
<!--        <design-2021-apprentice-multistep-form-wizard-form-header-component title="Instellingen"-->
<!--                                                                            :description="description">-->
<!--        </design-2021-apprentice-multistep-form-wizard-form-header-component>-->

<!--        <div class="errors"-->
<!--             v-if="hasError">-->
<!--            <b-alert class="project-name-error"-->
<!--                     show-->
<!--                     variant="danger"-->
<!--                     v-for="(error, index) in errors"-->
<!--                     :key="`error-${index}`"-->
<!--                     v-if="error.error">-->
<!--                {{ error.message }}-->
<!--            </b-alert>-->
<!--        </div>-->

<!--        <b-form-group class="portfolio-settings-course-group"-->
<!--                      label="Vak"-->
<!--                      label-for="settings-course-select">-->
<!--            <template v-slot:label>-->
<!--                Vak: <span class="required">*</span>-->
<!--            </template>-->
<!--            <b-form-select class="apprentice-primary-select"-->
<!--                           id="settings-course-select"-->
<!--                           v-model="selectedCourse"-->
<!--                           :options="courses"-->
<!--                           text-field="text"-->
<!--                           value-field="value"-->
<!--                           @change="updateCourse">-->
<!--            </b-form-select>-->
<!--        </b-form-group>-->

<!--        <b-form-group class="portfolio-settings-custom-banner-group"-->
<!--                      label="Aangepaste vak banner:"-->
<!--                      label-for="settings-custom-banner-upload">-->

<!--            <b-form-file class="apprentice-file-upload portfolio-settings-custom-banner"-->
<!--                         id="settings-custom-banner-upload"-->
<!--                         v-model="file"-->
<!--                         accept="image/jpeg"-->
<!--                         :placeholder="'Aangepaste banner'"-->
<!--                         ref="bannerUpload"-->
<!--                         @input="updateBannerSetting">-->
<!--            </b-form-file>-->
<!--        </b-form-group>-->

<!--        <div class="seasonal-dates">-->
<!--            <b-form-group class="portfolio-settings-season-group"-->
<!--                          label="Schooljaar"-->
<!--                          label-for="settings-season-select">-->
<!--                <template v-slot:label>-->
<!--                    Schooljaar: <span class="required">*</span>-->
<!--                </template>-->
<!--                <b-form-select class="apprentice-primary-select"-->
<!--                               id="settings-season-select"-->
<!--                               v-model="selectedSeason"-->
<!--                               :options="seasons"-->
<!--                               @input="updateSeason">-->
<!--                </b-form-select>-->
<!--            </b-form-group>-->

<!--            <b-form-group class="portfolio-settings-season-start-group"-->
<!--                          label="Start datum"-->
<!--                          label-for="settings-season-start-datepicker">-->
<!--                <template v-slot:label>-->
<!--                    Start datum: <span class="required">*</span>-->
<!--                </template>-->
<!--                <b-form-invalid-feedback >-->
<!--                    Kies eerst een startdatum voor je verder gaat.-->
<!--                </b-form-invalid-feedback>-->
<!--                <b-form-datepicker class="apprentice-date-picker season-start-date"-->
<!--                                   id="settings-season-start-datepicker"-->
<!--                                   v-model="settings.start_date"-->
<!--                                   menu-class="datedropdown"-->
<!--                                   start-weekday="1"-->
<!--                                   now-button-->
<!--                                   reset-button-->
<!--                                   right-->
<!--                                   today-variant="primary"-->
<!--                                   nav-button-variant="primary"-->
<!--                                   locale="nl"-->
<!--                                   aria-controls="Kies een datum"-->
<!--                                   label-reset-button="reset"-->
<!--                                   label-no-date-selected="Geen datum geselecteerd"-->
<!--                                   :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"-->
<!--                                   @input="updateSeasonStart">-->
<!--                </b-form-datepicker>-->
<!--            </b-form-group>-->
<!--            <b-form-group class="portfolio-settings-season-end-group"-->
<!--                          label="Eind datum"-->
<!--                          label-for="settings-season-end-datepicker">-->
<!--                <template v-slot:label>-->
<!--                    Eind datum: <span class="required">*</span>-->
<!--                </template>-->
<!--                <b-form-invalid-feedback >-->
<!--                    Kies eerst een startdatum voor je verder gaat.-->
<!--                </b-form-invalid-feedback>-->
<!--                <b-form-datepicker class="apprentice-date-picker season-end-date"-->
<!--                                   id="settings-season-end-datepicker"-->
<!--                                   v-model="settings.end_date"-->
<!--                                   menu-class="datedropdown"-->
<!--                                   start-weekday="1"-->
<!--                                   now-button-->
<!--                                   reset-button-->
<!--                                   right-->
<!--                                   today-variant="primary"-->
<!--                                   nav-button-variant="primary"-->
<!--                                   locale="nl"-->
<!--                                   aria-controls="Kies een datum"-->
<!--                                   label-reset-button="reset"-->
<!--                                   label-no-date-selected="Geen datum geselecteerd"-->
<!--                                   :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"-->
<!--                                   @input="updateSeasonEnd">-->
<!--                </b-form-datepicker>-->
<!--            </b-form-group>-->
<!--        </div>-->

<!--        <b-form-group class="portfolio-settings-editor-type-group"-->
<!--                      label="Editor type"-->
<!--                      label-for="settings-editor-type-select">-->
<!--            <template v-slot:label>-->
<!--                Editor type: <span class="required">*</span>-->
<!--            </template>-->
<!--            <b-form-select class="apprentice-primary-select"-->
<!--                           id="settings-editor-type-select"-->
<!--                           v-model="selectedEditorType"-->
<!--                           :options="editorTypes"-->
<!--                           @input="updateEditorType">-->
<!--            </b-form-select>-->
<!--        </b-form-group>-->
<!--    </div>-->
</template>

<script>
import $ from 'jquery';

function foreReload (callback) {
    requestAnimationFrame(() => {
        requestAnimationFrame(callback)
    })
}

export default {
    name: "design-2021-apprentice-portfolio-wizard-second-step-component",
    props: {
        value:Object,
        seasonsIn: {
            type: Array,
            required: true,
        },
        coursesIn: {
            type: Array,
            required: true,
        },
    },
    data(){
        return {
            description: `Hier kan je verschillende instelinngen instellen voor het project.`,
            settings: this.value,
            selectedCourse: this.value.course ? this.value.course : null,
            selectedSeason: this.value.season ? this.value.season : this.seasonsIn[0].id,
            selectedEditorType: this.value.editor_type ? this.value.editor_type : null,
            editorTypes: [
                {value: null, text: 'Kies een editor type', disabled: true},
                {value: 'oo', text: 'Only Office'},
                {value: 'moo', text: 'Microsoft Office Online'},
                {value: 'sp', text: 'Office 365'},
                {value: 'gd', text: 'Google Docs'}
            ],
            file: null,
            hasError: false,
            errors: {
                course: {
                    error: false,
                    message: 'Je hebt nog geen vak geselecteerd'
                },
                season: {
                    error: false,
                    message: 'Je hebt nog geen schooljaar geselecteerd'
                },
                season_start_date: {
                    error: false,
                    message: 'Schooljaar startdatum is verplicht'
                },
                season_end_date: {
                    error: false,
                    message: 'Schooljaar einddatum is verplicht'
                },
                editor_type: {
                    error: false,
                    message: 'Je hebt geen editor type geselecteerd'
                },
            },
        }
    },

    mounted() {
        if(this.selectedSeason !== ''){
            this.settings.season = this.seasonsIn
                                    .filter(season => season.id === this.selectedSeason)
                                    .shift();
        }
    },
    computed: {
        courses() {
            if(this.coursesIn.length === 0){
                return []
            }

            let courses = this.coursesIn.map(course => {
                return {
                    value: course.id,
                    text: course.name,
                }
            });

            courses.unshift({
                value: null,
                text: 'Kies een vak',
            });

            return courses;
        },

        seasons() {
            if(this.seasonsIn.length === 0){
                return []
            }

            let seasons = this.seasonsIn.map(season => {
                return {
                    value: season.id,
                    text: season.season,
                }
            });

            seasons.unshift({
                value: null,
                text: 'Kies een schooljaar',
                disabled: true,
            });

            return seasons;
        }
    },

    methods:{
        updateCourse(courseId){
            this.settings.course = this.coursesIn
                .filter(course => course.id === courseId)
                .shift();
            this.updateSettings();
        },

        updateSeason(seasonId){
            this.settings.season = this.seasonsIn
                .filter(season => season.id === seasonId)
                .shift();
            this.updateSettings();
        },

        updateSeasonStart(seasonStart){
            this.settings.start_date = seasonStart;
            this.updateSettings();
        },

        updateSeasonEnd(seasonEnd){
            this.settings.end_date = seasonEnd;
            this.updateSettings();
        },

        updateEditorType(editorTypeId){
            this.settings.editor_type = this.editorTypes
                .filter(type => type.value === editorTypeId)
                .shift();
            this.updateSettings();
        },

        updateBannerSetting(bannerFile){
            this.settings.banner = bannerFile;
            this.updateSettings();
        },

        updateSettings(){
            this.$emit('input', this.settings);
        },

        async checkForErrors(){
            this.hasError = false;
            this.errors.course.error = false;
            this.errors.season.error = false;
            this.errors.editor_type.error = false;
            this.errors.season_start_date.error = false;
            this.errors.season_end_date.error = false;

            if(this.selectedCourse === null ){
                this.hasError = true;
                this.errors.course.error = true;
            }

            if(this.selectedSeason === null){
                this.hasError = true;
                this.errors.season.error = true;
            }

            if(this.selectedEditorType === null){
                this.hasError = true;
                this.errors.editor_type.error = true;
            }

            if(this.settings.start_date === ''){
                this.hasError = true;
                this.errors.season_start_date.error = true;
            }

            if(this.settings.end_date === '' ){
                this.hasError = true;
                this.errors.season_end_date.error = true;
            }

            const response = this.hasError;
            return await response;

            if(this.hasError){
                Vue.nextTick(() => {
                    foreReload( () => {
                        const scrollPos = $(`.portfolio-settings .errors`)[0].offsetTop - 30;
                        $('.main-content').animate({ scrollTop: scrollPos,}, 500);
                    });
                });
            }
        }
    }
}
</script>

<style scoped lang="scss">
    input,
    select,
    .apprentice-date-picker {
        margin-bottom: 0;
    }

    .portfolio-settings-custom-banner-group ::v-deep {
        > label + div {
          height: 51px;
        }
    }

    @media(min-width: map-get($grid-breakpoints, 'xxl')){
        .seasonal-dates {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            column-gap: map-get($grid-gutter-spacing, 'fifteen');
            margin-bottom: $grid-gutter-width;

            > .form-group {
                flex: 1 1 calc(33% - 15px);
                margin-bottom: 0;
            }
        }
    }

</style>
